<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Tác vụ cá nhân - Thanh tra chấm BTVN</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="example mb-10">
        <div class="row align-items-end">
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Bài tập về nhà</label>
            <el-input class="w-100" v-model="query.class_keyword" placeholder="Nhập mã bài tập"></el-input>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Học viên làm bài</label>
            <el-input class="w-100" v-model="query.student_keyword"
              placeholder="Nhập họ tên, mã, số điện thoại"></el-input>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Hình thức bài tập</label>
            <el-select class="w-100" v-model="query.exercise_formats" multiple filterable collapse-tags
              placeholder="Chọn hình thức">
              <el-option label="Speaking" value="1"></el-option>
              <el-option label="Writing" value="2"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Phân loại thanh tra</label>
            <el-select class="w-100" v-model="query.types" multiple filterable collapse-tags placeholder="Chọn loại">
              <el-option label="Định kỳ" value="1"></el-option>
              <el-option label="Phúc khảo" value="2"></el-option>
              <el-option label="Làm lại BTVN fail" value="3"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Trạng thái</label>
            <el-select class="w-100" v-model="query.status" multiple filterable collapse-tags
              placeholder="Chọn trạng thái">
              <el-option label="Cần thanh tra" value="0"></el-option>
              <el-option label="Cần chấm lại" value="1"></el-option>
              <el-option label="Hoàn thành" value="2"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Kết quả thanh tra</label>
            <el-select class="w-100" v-model="query.result" clearable placeholder="Chọn kết quả">
              <el-option label="Đạt" value="1"></el-option>
              <el-option label="Không đạt" value="2"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Thời gian tạo bản ghi</label>
            <date-picker class="w-100" v-model="query.created_at" type="date" format="DD-MM-YYYY"
              value-type="YYYY-MM-DD" range placeholder="Chọn khoảng thời gian"
              @change="handleDateChange"></date-picker>
          </div>
        </div>
        <!-- search button removed: auto debounce used like Management page -->
        <div class="example-preview table-responsive overflow-auto mt-8">
          <table class="table table-hover table-bordered table-vertical-center b-table"
            style="text-align: center; table-layout: fixed;">
            <thead>
              <tr>
                <th style="width: 80px;">Mã bài tập</th>
                <th style="width: 200px;">Bài tập về nhà</th>
                <th style="width: 80px;">Hình thức</th>
                <th style="width: 160px;">Học viên làm bài</th>
                <th style="width: 160px;">Giảng viên chấm</th>
                <th style="width: 120px;">Phân loại</th>
                <th style="width: 110px;">Trạng thái</th>
                <th style="width: 110px;">Kết quả</th>
                <th style="width: 100px;">Thời gian tạo</th>
                <th style="width: 120px;">Hành động</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr role="row" class="b-table-busy-slot">
                <td colspan="10" role="cell" class="">
                  <div class="text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="item in inspectionList" :key="item.id">
                <td>{{ item.id }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ item.homework }}</td>
                <td>{{ item.exercise_format }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ `${item.user_id + 100000} -
                  ${item.student_name}` }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ `${item.teacher_id + 100000} -
                  ${item.teacher_name}` }}</td>
                <td>{{ getInspectionTypeText(item.type) }}</td>
                <td><span :class="getStatusBadge(item.status)">{{ getStatusText(item.status) }}</span></td>
                <td>{{ getResultText(item.result) }}</td>
                <td>{{ formatDate(item.created_at) }}</td>
                <td>
                  <el-tooltip :content="actionTooltip(item)">
                    <button class="btn btn-icon btn-xs btn-outline-info mr-2" @click="inspectOrView(item)">
                      <i class="fa fa-eye"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip content="Chấm lại" v-if="item.status == 1">
                    <button class="btn btn-icon btn-xs btn-outline-warning" @click="regrade(item)">
                      <i class="fa fa-undo"></i>
                    </button>
                  </el-tooltip>
                </td>
              </tr>
              <tr v-if="inspectionList.length === 0 && !loading">
                <td colspan="10" class="event-title no-data">Không có dữ liệu</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end align-items-center mt-3">
          <div class="text-right">Tổng số bản ghi: <b class="text-primary">{{ total }}</b></div>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1" :click-handler="clickCallback"
        :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
        :pageLinkClass="'page-link'" :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'"
        :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
      </paginate>
    </div>


  </div>
</template>

<script>
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { INSPECTION_PERSONAL } from '@/core/services/store/inspection/inspection.module';
const _ = require('lodash');

export default {
  components: { DatePicker },
  name: 'InspectionHomeworkPersonal',
  data() {
    return {
      query: {
        class_keyword: '',
        student_keyword: '',
        exercise_formats: [],
        types: [],
        status: [],
        result: '',
        created_at: [],
      },
      inspectionList: [],
      last_page: 1,
      page: 1,
      total: 0,
      loading: true,
      is_disable_search: false,
    };
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Quản trị chất lượng', route: '' },
      { title: 'Tác vụ cá nhân - Thanh tra chấm BTVN', route: '' },
    ]);
    this.callApiGetList();
  },
  methods: {
    handleDateChange(value) {
      if (Array.isArray(value) && value.length === 2 && value[0] === null && value[1] === null) {
        this.query.created_at = [];
      } else {
        this.query.created_at = value;
      }
    },
    search: _.debounce(function () {
      this.page = 1;
      this.pushParamsUrl();
      this.callApiGetList();
    }, 200),
    clickCallback(obj) {
      this.page = obj;
      this.pushParamsUrl();
      this.callApiGetList();
    },
    pushParamsUrl() {
      this.$router.push({ name: 'inspection-homework-personal', query: { page: this.page, ...this.query } });
    },
    async callApiGetList() {
      try {
        const response = await this.$store.dispatch(INSPECTION_PERSONAL, {
          ...this.query,
          page: this.page,
          per_page: 20,
        });
        this.loading = false;
        this.inspectionList = response.data || [];
        this.last_page = response.pagination.last_page;
        this.total = response.pagination.total;
        this.is_disable_search = false;
      } catch (e) {
        this.loading = false;
        this.is_disable_search = false;
      }
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('vi-VN');
    },
    getStatusText(status) {
      const statusTexts = {
        0: 'Cần thanh tra',
        1: 'Cần chấm lại',
        2: 'Hoàn thành'
      };
      return statusTexts[status] || 'Không xác định';
    },
    getStatusBadge(status) {
      const statusClasses = {
        0: 'badge badge-warning',
        1: 'badge badge-info',
        2: 'badge badge-success'
      };
      return statusClasses[status] || 'badge badge-secondary';
    },
    getInspectionTypeText(type) {
      const map = {
        1: 'Định kỳ',
        2: 'Phúc khảo',
        3: 'Làm lại BTVN Fail',
      };
      return map[type] || '';
    },
    getResultText(result) {
      const map = { 1: 'Đạt', 2: 'Không đạt' };
      return result ? map[result] : '';
    },
    actionTooltip(item) {
      return item.status == 0 ? 'Thanh tra' : 'Xem lại bài tập thanh tra';
    },
    inspectOrView(item) {
      const query = {};
      if (item.status !== 0) {
        query.mode = 'show';
      }
      const routeData = this.$router.resolve({
        name: 'inspection-task-detail',
        params: { id: item.id },
        query
      });

      window.open(routeData.href, '_blank');
    },
    regrade(item) {
      const routeData = this.$router.resolve({
        name: "mark-homework-v2", params: { id: item.class_id },
        query: {
          classroom_id: item.class_id, lesson: item.lesson,
          student_id: item.user_id, overall_id: item.overall_result_id,
          typeReMark: 'remark-inspection',
          inspection_id: item.id,
          order: item.order
        }
      });
      window.open(routeData.href, '_blank');
      // this.$message.warning(`Chấm lại bài: ${item.id}`);
    },
  },
  watch: { query: { handler() { this.search(); }, deep: true } },
};
</script>

<style lang="scss" scoped></style>
